module.exports = "/images/ca.svg?3a2c29cb5d9f5b63d09f769b9f049aaa";